var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "dialog",
        visible: _vm.innerVisible,
        title: _vm.title,
        width: _vm.$selectByLang("350px", "390px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("80px", "120px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.operation === 0,
                  expression: "operation===0"
                }
              ],
              attrs: { label: _vm.$t("queryJob.takeoffTime") }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  no: "atd",
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm",
                  editable: false
                },
                model: {
                  value: _vm.form.atd,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "atd", $$v)
                  },
                  expression: "form.atd"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.operation === 1,
                  expression: "operation===1"
                }
              ],
              attrs: { label: _vm.$t("CargoMsg.Cargo_ArrivalTime") }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  no: "ata",
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm"
                },
                model: {
                  value: _vm.form.ata,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "ata", $$v)
                  },
                  expression: "form.ata"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.operation !== 0 && _vm.operation !== 1,
                  expression: "operation!==0&&operation!==1"
                }
              ],
              attrs: { label: _vm.$t("queryJob.deliveryTime") }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  no: "handOffDateTime",
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm"
                },
                model: {
                  value: _vm.form.handOffDateTime,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "handOffDateTime", $$v)
                  },
                  expression: "form.handOffDateTime"
                }
              })
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: _vm.$t("SeaExport.Flight") } }, [
            _vm._v(
              _vm._s(
                _vm.form.flightDescription
                  ? _vm.form.flightDescription.flightNo
                  : ""
              )
            )
          ]),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("queryJob.dateOfDeparture") } },
            [_vm._v(_vm._s(_vm.ColumnUtils.dateLabelFunc(_vm.form.etd)))]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.AirlineCompany") } },
            [
              _vm._v(
                _vm._s(
                  _vm.ColumnUtils.resolveColumnLabel(
                    _vm.TYPE_NAMES.basic_data_Company,
                    "cmpIdx",
                    _vm.form.flightDescription
                      ? _vm.form.flightDescription.carrierId
                      : 0,
                    "chineseName"
                  )
                )
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Payment.portOfLoading") } },
            [_vm._v(_vm._s(_vm.loadingPortCodeLabel))]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Payment.portOfDestination") } },
            [_vm._v(_vm._s(_vm.destinationPortCodeLable))]
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Confirm", type: "primary" },
              on: { click: _vm.clickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }